import * as Sentry from '@sentry/react'

import { googleCallToActionsResponseSchema } from './schemas'

// Same lenient-parse-with-Sentry-capture convention as
// domain/googleAudiences/mappers.js / domain/googleConversionGoals/mappers.js
// — fall through to the raw response on schema mismatch rather than breaking
// the selector.
export function mapGoogleCallToActionsResponse(data) {
  const parsed = googleCallToActionsResponseSchema.safeParse(data)
  if (!parsed.success) {
    Sentry.captureException(parsed.error)
  }
  return parsed.success ? parsed.data : Array.isArray(data) ? data : []
}
